<template>
  <div>
    <span class="hse-RichInput__label">{{ label }}</span>
    <HseSpace size="small_2x" vertical />
    <HseRadioGroup class="group">
      <div  v-for="option in options" :key="option.value"    class="radioWithTooltip">     
          <HseRadio
        class="item"
        :key="option.value"
        :value="option.value"
        :modelValue="value"
        @change="setValue"
        :inactive="disabled"
       
      >
        {{ option.label }}
      </HseRadio>
        <HseTooltip :content="option.tooltip">
          <IconStatusInfo />
        </HseTooltip>
      </div>
     
    </HseRadioGroup>
  </div>
</template>
<script>
  import { HseRadioGroup, HseRadio, HseSpace, HseTooltip, IconStatusInfo} from '@hse-design/vue'
  export default {
    components: {
      HseRadioGroup,
      HseRadio,
      HseSpace,
      HseTooltip,
      IconStatusInfo,
    },
    data: () => ({
      value: '',
    }),
    created () {
      this.value = this.defaultValue
    },
    watch: {
      defaultValue() {
        this.value = this.defaultValue
      },
    },
    props: ['options', 'label', 'defaultValue', 'disabled'],
    methods: {
      setValue (val) {
        this.value = val
        this.$emit('change', val)
      },
    },
  }
</script>

<style scoped>
.group {
  display: flex;
  margin: 0 -15px;
}
.item {
  flex: 1;
  padding: 0 15px;
}

.radioWithTooltip {
  display: flex;
  flex: 1;
  padding-right: 15px;
}

.radioWithTooltip>div:last-child {
 margin-bottom: 12px ;
}


</style>